exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.help-tip-right {\n    left: 30px !important;\n    right: auto !important;\n}\n.help-tip-smaller {\n    font-size: 14px !important;\n    line-height: 1.4 !important;\n}\n", ""]);

// exports
